import axios from "@/libs/api.request";
import config from "@/config";
import { getToken } from "@/libs/util";
import { paramFormat } from "@/api/fn";

const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;

export default {
  // sysQueryRoleById(data) {
  //   let token = getToken();
  //   let param = {"id": data.id};
  //   let url = baseUrl + "/sys/role/sysQueryRoleById?id=" + param.id;
  //   return axios.request({
  //     url: url,
  //     data: param,
  //     dataType: "json",
  //     contentType: "application/json; charset=utf-8",
  //     headers: {
  //       token: token,
  //       "Content-Type": "application/json; charset=utf-8"
  //     },
  //     method: "GET"
  //   });
  // },
  //获取页面数据
  querySensorByFilter(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/sensor/querySensorByFilter",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //新建
  newSensor(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/sensor/newSensor",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //编辑
  updateSensorById(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/sensor/updateSensorById",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  updateSensorWarningLevel(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/incline/updateSensorWarningLevel",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  //删除
  deleteSensorById(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/sensor/deleteSensorById",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
//详细查询
querySensorById(data) {
  let token = getToken();
  let param = {"id": data.id};
  let url = baseUrl + "/sys/sensor/querySensorById/" + param.id;
  return axios.request({
    url: url,
    data: param,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    headers: {
      token: token,
      "Content-Type": "application/json; charset=utf-8"
    },
    method: "GET"
  });
},
  sysNewRole(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/role/sysNewRole",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  roleMenuList(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/menu/list",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  resetExProperties(data) {
    let token = getToken();
    return axios.request({
      url: baseUrl + "/sys/directory/resetExProperties",
      data: data,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
};
